import React, { useRef, useState } from "react";
import { createContext } from "react";
import { FlyToInterpolator } from "react-map-gl";

export const MapContext = createContext({});

export function MapProvider({
  children,
  initialViewState = DEFAULT_VIEW_STATE
}) {
  /**
   * Control viewState of the map
   */
  const [viewState, setViewState] = useState({
    ...initialViewState
  });

  /**
   * Fly to coordinates
   */

  const flyTo = vs =>
    setViewState(
      vs({
        ...viewState,
        transitionDuration: 350,
        transitionInterpolator: new FlyToInterpolator()
      })
    );

  /**
   * Used for a shared GL context
   */
  const mapRef = useRef({});
  const deckRef = useRef();

  /**
   * Gets the next calculated view state, then
   * applies limitations to it so we don't go
   * out of bounds.
   *
   * @todo add function that wraps setBounds
   * and checks for correct bounds format
   */
  const [bounds, setBounds] = useState();
  const setViewStateInBounds = vsFn => {
    setViewState(vs => {
      /**
       * Can pass either a function or an object. You'd
       * pass a function to get access to the previous
       * viewState.
       */
      const nextViewState = typeof vsFn === "function" ? vsFn(vs) : vsFn;
      if (bounds) {
        let { latitude, longitude, ...rest } = nextViewState;
        const [
          [minLongitude, minLatitude],
          [maxLongitude, maxLatitude]
        ] = bounds;

        if (latitude < minLatitude) {
          latitude = minLatitude;
        } else if (latitude > maxLatitude) {
          latitude = maxLatitude;
        }

        if (longitude < minLongitude) {
          longitude = minLongitude;
        } else if (longitude > maxLongitude) {
          longitude = maxLongitude;
        }

        return {
          ...vs,
          ...rest,
          latitude,
          longitude
        };
      } else {
        return nextViewState;
      }
    });
  };

  const [markers, setMarkers] = useState([]);

  return (
    <MapContext.Provider
      value={{
        viewState,
        setViewState,
        setViewStateInBounds,
        flyTo,
        mapRef,
        deckRef,
        markers,
        setMarkers,
        bounds,
        setBounds
      }}
    >
      {children}
    </MapContext.Provider>
  );
}

const DEFAULT_VIEW_STATE = {
  latitude: -37.8136,
  longitude: 144.96332,
  zoom: 13.5,
  pitch: 40,
  bearing: 0
};
